'use client'
import dynamic from 'next/dynamic'

const FacebookSDK = dynamic(() => import('./facebook-sdk').then(m => m.FacebookSDK))

interface ThirdPartySDKsProps {
  removeFacebook?: boolean
}

export function ThirdPartySDKs({ removeFacebook = false }: ThirdPartySDKsProps) {
  return <>{!removeFacebook ? <FacebookSDK /> : null}</>
}
